/**
 * Registration route constants
 */
export const REGISTRATION_ROUTES = {
  LOGIN: '/login',
  REGISTER: '/register',
  REGISTER_CREATE_ACCOUNT: '/register/create-account',
  REGISTER_SUCCESS: '/register/success',
  REGISTER_FEEDBACK: '/register/feedback',
  REGISTER_FEEDBACK_COMMENT: '/register/feedback/comment',
  REGISTER_FEEDBACK_THANK_YOU: '/register/feedback/thank-you',
  DOWNLOAD_APP: '/register/download-app',
} as const;

export type RegistrationRoutePath = typeof REGISTRATION_ROUTES[keyof typeof REGISTRATION_ROUTES];
